export const MenuButtonUiBase = `inline-flex items-center justify-center w-full rounded-md pl-5 py-2 text-sm focus:outline-none font-secondary`
export const MenuButtonUi = `${MenuButtonUiBase} text-white shadow-sm`
export const MenuButtonUiDark = `${MenuButtonUiBase} text-black`
export const MenuItemsProfileUi = `absolute mt-2 w-56 rounded-md shadow-lg bg-white focus:outline-none font-secondary z-10`
export const MenuItemsClassesUi = `absolute right-[10rem] mt-2 w-56 rounded-md shadow-lg bg-white focus:outline-none font-secondary`

export const Transitions = {
    Enter: 'transition ease-out duration-100',
    EnterFrom: 'transform opacity-0 scale-95',
    EnterTo: 'transform opacity-100 scale-100',
    Leave: 'transition ease-in duration-75',
    LeaveFrom: 'transform opacity-100 scale-100',
    LeaveTo: 'transform opacity-0 scale-95',
}
